const o=o=>Math.round(100*o)/100;export{o as roundSize};